import Button from '@xunlei/thunder-ui-vue/lib/button.js';
import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';

var NAMESPACE = 'td';

var Dropdown = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-dropdown" }, [_c('div', { staticClass: "td-dropdown-group" }, [_c('td-button', { attrs: { "size": "large", "disabled": _vm.disabled }, on: { "click": _vm.handleButtonClick } }, [_vm._t("default")], 2), _vm._v(" "), _c('td-button', { attrs: { "size": "large", "disabled": _vm.disabled }, on: { "click": function click($event) {
          $event.stopPropagation();return _vm.handleDropClick($event);
        } } }, [_c('td-icon', { attrs: { "type": "arrow-drop" } })], 1)], 1), _vm._v(" "), !_vm.customMenuEnabled ? _c('ul', { directives: [{ name: "show", rawName: "v-show", value: _vm.menuVisible, expression: "menuVisible" }], staticClass: "td-dropdown-menu" }, _vm._l(_vm.menus, function (menu) {
      return _c('li', { key: menu, staticClass: "td-dropdown-menu__item", on: { "click": function click($event) {
            return _vm.handleMenuClick(menu);
          } } }, [_vm._v(" " + _vm._s(menu) + " ")]);
    }), 0) : _vm._e()]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-dropdown',

  components: {
    TdButton: Button,
    TdIcon: Icon
  },

  props: {
    menus: Array,
    customMenuEnabled: Boolean,
    disabled: Boolean
  },

  data: function data() {
    return {
      menuVisible: false
    };
  },


  methods: {
    handleButtonClick: function handleButtonClick() {
      this.$emit('click');
    },
    handleDropClick: function handleDropClick() {
      this.menuVisible = true;
      this.$emit('drop-click');
    },
    handleMenuClick: function handleMenuClick(menu) {
      this.$emit('input', menu);
    }
  },

  mounted: function mounted() {
    var _this = this;

    document.addEventListener('click', function () {
      _this.menuVisible = false;
    });
  }
};

Dropdown.install = function (Vue) {
  Vue.component(Dropdown.name, Dropdown);
};

export default Dropdown;
